import {useContext} from 'react';
import AttachmentContext from './attachment-context';

const useAttachment = () => {
  const context = useContext(AttachmentContext);
  return context
};

export default useAttachment;
